<main id="main-wrapper">
    <div class="master-grid">
        <div class="t-row">
            <div class="col c--12">
                <div class="content-in">
                    <h1 class="central-title">{{title}}</h1>
                    <div class="normal-txt-in txt-center">
                        <p>
                            Je m'appelle Housni Issouffa. 
                            Je suis développeur web front-end et infographiste, originaire des Comores et vis actuellement à Moroni. 
                            Dans ce site web j'aimerais partager un peu l'expérience qu'on vit dans l'univers du web et aussi parler de tout ce qui me touche à cœur en général.
                        </p>
                    </div>
                    <!-- <div class="txt-center">
                        <img src="./assets/laptop-in-hands.png" alt="Laptop in hands">
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</main>